import type { ReactElement } from 'react';

import { ModelDiscountsCard } from '../dashboard/ModelDiscountsCard.js';
import { ModelDurationTiersCard } from '../dashboard/ModelDurationTiersCard.js';
import { SettingsStack } from './SettingsStack.js';

export function SettingsDiscountsPage(): ReactElement {
  return (
    <SettingsStack
      titleKey="common.studio.settings.discountsTitle"
      hintKey="common.studio.settings.discountsHint"
    >
      <ModelDurationTiersCard />
      <ModelDiscountsCard />
    </SettingsStack>
  );
}
